export default __webpack_public_path__ + "static/air-corporate-we-chat-af30edc15b6ccd6046cbb47252d91128.png";